export const PAMPAS_CAT = "https://auth.mhome.ai";
export const AUTH_API = "https://prod.s.mhome.ai/api/v1";
export const CN_AUTH_API = process.env.REACT_APP_CN_AUTH_API || "";
export const USER_AUTH_DOMAIN = "user-auth.mhome.ai";
export const DEVELOPER_AUTH_DOMAIN = "dev-auth.mhome.ai";
